module.exports = __webpack_public_path__ + "media/images/wealthbar/transfers/transfer-deposit-2x-eb448522c14684775faaa210278ac4ad.png";